{
  "REPORT": {
    "HEADER": "Converses",
    "LOADING_CHART": "S'estan carregant dades del gràfic...",
    "NO_ENOUGH_DATA": "No hem rebut suficients punts de dades per generar l'informe. Torneu-ho a provar més endavant.",
    "DOWNLOAD_AGENT_REPORTS": "Descarregar Informes d'Agent",
    "DATA_FETCHING_FAILED": "No s'han pogut obtenir les dades. Intenta-ho més tard.",
    "SUMMARY_FETCHING_FAILED": "No s'ha pogut obtenir el resum; torna-ho a provar més tard.",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Converses",
        "DESC": "( Total )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Missatges d'entrada",
        "DESC": "( Total )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Missatges de sortida",
        "DESC": "( Total )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Primer Temps de Resposta",
        "DESC": "( Promig )",
        "INFO_TEXT": "Nombre total de converses utilitzades per al càlcul:",
        "TOOLTIP_TEXT": "El temps de primera resposta (FRT) és {metricValue} (basat en {conversationCount} converses)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Temps de resolució",
        "DESC": "( Promig )",
        "INFO_TEXT": "Nombre total de converses utilitzades per al càlcul:",
        "TOOLTIP_TEXT": "El temps de resolució (RT) és {metricValue} (basat en {conversationCount} converses)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Total de resolucions",
        "DESC": "( Total )"
      },
      "BOT_RESOLUTION_COUNT": {
        "NAME": "Total de resolucions",
        "DESC": "( Total )"
      },
      "BOT_HANDOFF_COUNT": {
        "NAME": "Recompte de lliuraments",
        "DESC": "( Total )"
      },
      "REPLY_TIME": {
        "NAME": "Temps d'espera del client",
        "TOOLTIP_TEXT": "El temps d'espera és {metricValue} (basat en {conversationCount} respostes)",
        "DESC": ""
      }
    },
    "DATE_RANGE_OPTIONS": {
      "TODAY": "Avui",
      "YESTERDAY": "Ahir",
      "LAST_7_DAYS": "Últims 7 dies",
      "LAST_30_DAYS": "Últims 30 dies",
      "THIS_MONTH": "Aquest mes",
      "LAST_MONTH": "El mes passat",
      "LAST_3_MONTHS": "Últims tres mesos",
      "LAST_6_MONTHS": "Últims sis mesos",
      "LAST_YEAR": "Darrer any",
      "CUSTOM_DATE_RANGE": "Interval de dates personalitzat"
    },
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Aplica",
      "PLACEHOLDER": "Seleccioneu l'interval de dates"
    },
    "GROUP_BY_FILTER_DROPDOWN_LABEL": "Agrupar per",
    "DURATION_FILTER_LABEL": "Durada",
    "GROUPING_OPTIONS": {
      "DAY": "Dia",
      "WEEK": "Setmana",
      "MONTH": "Mes",
      "YEAR": "Any"
    },
    "GROUP_BY_DAY_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Dia"
      }
    ],
    "GROUP_BY_WEEK_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Dia"
      },
      {
        "id": 2,
        "groupBy": "Setmana"
      }
    ],
    "GROUP_BY_MONTH_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Dia"
      },
      {
        "id": 2,
        "groupBy": "Setmana"
      },
      {
        "id": 3,
        "groupBy": "Mes"
      }
    ],
    "GROUP_BY_YEAR_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Day"
      },
      {
        "id": 2,
        "groupBy": "Week"
      },
      {
        "id": 3,
        "groupBy": "Month"
      }
    ],
    "BUSINESS_HOURS": "Horari comercial",
    "FILTER_ACTIONS": {
      "CLEAR_FILTER": "Esborra els filtres",
      "EMPTY_LIST": "No s'ha trobat agents"
    },
    "DRILLDOWN": {
      "RESULT_COUNT_CONVERSATION": "Converses: {count}",
      "RESULT_COUNT_MESSAGE": "Missatges: {count}",
      "EMPTY": "No s'han trobat registres per a aquesta barra.",
      "ERROR": "No s'han pogut carregar els registres. Torna-ho a provar.",
      "LOAD_MORE": "Carrega'n més",
      "PREVIOUS_BUCKET": "Barra anterior",
      "NEXT_BUCKET": "Barra següent",
      "UNKNOWN_CONTACT": "Contacte desconegut",
      "UNKNOWN_INBOX": "Safata d'entrada desconeguda",
      "UNASSIGNED_AGENT": "Sense assignar",
      "NO_MESSAGE_CONTENT": "Missatge sense contingut",
      "MESSAGE_CREATED_AT": "Missatge creat el {time}",
      "EVENT_OCCURRED_AT": "Esdeveniment ocorregut el {time}",
      "INCOMING_MESSAGE": "Missatge d'entrada",
      "OUTGOING_MESSAGE": "Missatge de sortida",
      "VIEW_ALL": "Mostra a les converses",
      "VIEW_ALL_LIMIT": "Només les barres amb un màxim de {limit} converses s'obren a la llista de converses.",
      "HIDDEN_COUNT": "No es mostren perquè no ets membre de la seva safata d'entrada: {count}"
    },
    "PAGINATION": {
      "RESULTS": "Showing {start} to {end} of {total} results",
      "PER_PAGE_TEMPLATE": "{size} / page"
    }
  },
  "AGENT_REPORTS": {
    "HEADER": "Visió general dels agents",
    "DESCRIPTION": "Easily track agent performance with key metrics such as conversations, response times, resolution times, and resolved cases. Click an agent’s name to learn more.",
    "LOADING_CHART": "S'estan carregant dades del gràfic...",
    "NO_ENOUGH_DATA": "No hem rebut suficients punts de dades per generar l'informe. Torneu-ho a provar més endavant.",
    "DOWNLOAD_AGENT_REPORTS": "Descarregar Informes d'Agent",
    "FILTER_DROPDOWN_LABEL": "Seleccionar Agent",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Converses",
        "DESC": "( Total )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Missatges d'entrada",
        "DESC": "( Total )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Missatges de sortida",
        "DESC": "( Total )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Primer Temps de Resposta",
        "DESC": "( Promig )",
        "INFO_TEXT": "Nombre total de converses utilitzades per al càlcul:",
        "TOOLTIP_TEXT": "El temps de primera resposta (FRT) és {metricValue} (basat en {conversationCount} converses)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Temps de resolució",
        "DESC": "( Promig )",
        "INFO_TEXT": "Nombre total de converses utilitzades per al càlcul:",
        "TOOLTIP_TEXT": "El temps de resolució (RT) és {metricValue} (basat en {conversationCount} converses)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Total de resolucions",
        "DESC": "( Total )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Últims 7 dies"
      },
      {
        "id": 1,
        "name": "Últims 30 dies"
      },
      {
        "id": 2,
        "name": "Últims tres mesos"
      },
      {
        "id": 3,
        "name": "Últims sis mesos"
      },
      {
        "id": 4,
        "name": "Darrer any"
      },
      {
        "id": 5,
        "name": "Interval de dates personalitzat"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Aplica",
      "PLACEHOLDER": "Seleccioneu l'interval de dates"
    }
  },
  "LABEL_REPORTS": {
    "HEADER": "Visió general de les etiquetes",
    "DESCRIPTION": "Fes el seguiment del rendiment de les etiquetes amb mètriques clau com converses, temps de resposta, temps de resolució i casos resolts.",
    "LOADING_CHART": "S'estan carregant dades del gràfic...",
    "NO_ENOUGH_DATA": "No hem rebut suficients punts de dades per generar l'informe. Torneu-ho a provar més endavant.",
    "DOWNLOAD_LABEL_REPORTS": "Descarregar Informes d'etiquetes",
    "FILTER_DROPDOWN_LABEL": "Selecciona l'etiqueta",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Converses",
        "DESC": "( Total )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Missatges d'entrada",
        "DESC": "( Total )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Missatges de sortida",
        "DESC": "( Total )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Primer Temps de Resposta",
        "DESC": "(Mitjana)",
        "INFO_TEXT": "Nombre total de converses utilitzades per al càlcul:",
        "TOOLTIP_TEXT": "El temps de primera resposta (FRT) és {metricValue} (basat en {conversationCount} converses)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Temps de resolució",
        "DESC": "( Promig )",
        "INFO_TEXT": "Nombre total de converses utilitzades per al càlcul:",
        "TOOLTIP_TEXT": "El temps de resolució (RT) és {metricValue} (basat en {conversationCount} converses)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Total de resolucions",
        "DESC": "( Total )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Últims 7 dies"
      },
      {
        "id": 1,
        "name": "Últims 30 dies"
      },
      {
        "id": 2,
        "name": "Últims tres mesos"
      },
      {
        "id": 3,
        "name": "Últims sis mesos"
      },
      {
        "id": 4,
        "name": "Darrer any"
      },
      {
        "id": 5,
        "name": "Interval de dates personalitzat"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Aplica",
      "PLACEHOLDER": "Seleccioneu l'interval de dates"
    }
  },
  "INBOX_REPORTS": {
    "HEADER": "Visió general de la safata d'entrada",
    "DESCRIPTION": "Quickly view your inbox performance with key metrics like conversations, response times, resolution times, and resolved cases—all in one place. Click an inbox name for more details.",
    "LOADING_CHART": "S'estan carregant dades del gràfic...",
    "NO_ENOUGH_DATA": "No hem rebut suficients punts de dades per generar l'informe. Torneu-ho a provar més endavant.",
    "DOWNLOAD_INBOX_REPORTS": "Baixa els informes de la safata d'entrada",
    "FILTER_DROPDOWN_LABEL": "Selecciona Safata d'entrada",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Converses",
        "DESC": "( Total )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Missatges d'entrada",
        "DESC": "( Total )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Missatges de sortida",
        "DESC": "( Total )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Primer Temps de Resposta",
        "DESC": "( Promig )",
        "INFO_TEXT": "Nombre total de converses utilitzades per al càlcul:",
        "TOOLTIP_TEXT": "El temps de primera resposta (FRT) és {metricValue} (basat en {conversationCount} converses)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Temps de resolució",
        "DESC": "( Promig )",
        "INFO_TEXT": "Nombre total de converses utilitzades per al càlcul:",
        "TOOLTIP_TEXT": "El temps de resolució (RT) és {metricValue} (basat en {conversationCount} converses)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Total de resolucions",
        "DESC": "( Total )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Últims 7 dies"
      },
      {
        "id": 1,
        "name": "Últims 30 dies"
      },
      {
        "id": 2,
        "name": "Últims tres mesos"
      },
      {
        "id": 3,
        "name": "Últims sis mesos"
      },
      {
        "id": 4,
        "name": "Darrer any"
      },
      {
        "id": 5,
        "name": "Interval de dates personalitzat"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Aplica",
      "PLACEHOLDER": "Seleccioneu l'interval de dates"
    }
  },
  "TEAM_REPORTS": {
    "HEADER": "Visió general de l'equip",
    "DESCRIPTION": "Get a snapshot of your team’s performance with essential metrics, including conversations, response times, resolution times, and resolved cases. Click a team name for more details.",
    "LOADING_CHART": "S'estan carregant dades del gràfic...",
    "NO_ENOUGH_DATA": "No hem rebut suficients punts de dades per generar l'informe. Torneu-ho a provar més endavant.",
    "DOWNLOAD_TEAM_REPORTS": "Descarregar Informes d'equip",
    "FILTER_DROPDOWN_LABEL": "Selecciona equip",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Converses",
        "DESC": "( Total )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Missatges d'entrada",
        "DESC": "( Total )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Missatges de sortida",
        "DESC": "( Total )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Primer Temps de Resposta",
        "DESC": "( Promig )",
        "INFO_TEXT": "Nombre total de converses utilitzades per al càlcul:",
        "TOOLTIP_TEXT": "El temps de primera resposta (FRT) és {metricValue} (basat en {conversationCount} converses)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Temps de resolució",
        "DESC": "( Promig )",
        "INFO_TEXT": "Nombre total de converses utilitzades per al càlcul:",
        "TOOLTIP_TEXT": "El temps de resolució (RT) és {metricValue} (basat en {conversationCount} converses)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Total de resolucions",
        "DESC": "( Total )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Últims 7 dies"
      },
      {
        "id": 1,
        "name": "Últims 30 dies"
      },
      {
        "id": 2,
        "name": "Últims tres mesos"
      },
      {
        "id": 3,
        "name": "Últims sis mesos"
      },
      {
        "id": 4,
        "name": "Darrer any"
      },
      {
        "id": 5,
        "name": "Interval de dates personalitzat"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Aplica",
      "PLACEHOLDER": "Seleccioneu l'interval de dates"
    }
  },
  "CSAT_REPORTS": {
    "HEADER": "Informes CSAT",
    "NO_RECORDS": "No hi ha respostes de l'enquesta CSAT disponibles.",
    "DOWNLOAD": "Descarregar informes CSAT",
    "DOWNLOAD_FAILED": "No s'han pogut baixar els informes CSAT",
    "FILTERS": {
      "AGENTS": {
        "PLACEHOLDER": "Escull agents"
      }
    },
    "TABLE": {
      "HEADER": {
        "CONTACT_NAME": "Contacte",
        "AGENT_NAME": "Agent assignat",
        "RATING": "Valoració",
        "FEEDBACK_TEXT": "Comentaris"
      }
    },
    "METRIC": {
      "TOTAL_RESPONSES": {
        "LABEL": "Respostes totals",
        "TOOLTIP": "Nombre total de respostes recollides"
      },
      "SATISFACTION_SCORE": {
        "LABEL": "Puntuació de satisfacció",
        "TOOLTIP": "Nombre total de respostes positives / Nombre total de respostes * 100"
      },
      "RESPONSE_RATE": {
        "LABEL": "Taxa de resposta",
        "TOOLTIP": "Nombre total de respostes / Nombre total de missatges d'enquesta CSAT enviats * 100"
      }
    }
  },
  "BOT_REPORTS": {
    "HEADER": "Informes de bot",
    "METRIC": {
      "CONVERSATION_COUNT": {
        "LABEL": "Nre. de converses",
        "TOOLTIP": "Nombre total de converses amb missatges del bot"
      },
      "OUTGOING_COUNT": {
        "LABEL": "Nre. de respostes",
        "TOOLTIP": "Nombre total de missatges sortints"
      },
      "MESSAGE_COUNT": {
        "LABEL": "Nre. de respostes d'IA",
        "TOOLTIP": "Nombre total de missatges de resposta enviats pel bot"
      },
      "COPILOT_COUNT": {
        "LABEL": "Nre. de respostes preparades",
        "TOOLTIP": "Nombre total de suggeriments de copilot preparats pel bot per als agents"
      },
      "SUCCESS_RATE": {
        "LABEL": "Resolt per IA",
        "TOOLTIP": "Percentatge de converses resoltes per la IA sense trasllat a un agent"
      },
      "RESOLVE_TIME": {
        "LABEL": "Temps de resolució",
        "TOOLTIP": "Temps mitjà (mediana) des del primer missatge del client fins a l'últim missatge del bot o l'agent"
      },
      "TOTAL_CONVERSATIONS": {
        "LABEL": "Nre. de converses",
        "TOOLTIP": "Nombre total de converses gestionades pel bot"
      },
      "TOTAL_RESPONSES": {
        "LABEL": "Respostes totals",
        "TOOLTIP": "Nombre total de respostes enviades pel bot"
      },
      "RESOLUTION_RATE": {
        "LABEL": "Taxa de resolució",
        "TOOLTIP": "Nombre total de converses resoltes pel bot / Nombre total de converses gestionades pel bot * 100"
      },
      "HANDOFF_RATE": {
        "LABEL": "Taxa de trasllat",
        "TOOLTIP": "Nombre total de converses lliurades als agents / Nombre total de converses gestionades pel bot * 100"
      }
    },
    "GROUP_BY": {
      "NONE": "No agrupis",
      "INBOXES": "Safates d'entrada",
      "LABELS": "Etiquetes"
    },
    "GROUPED": {
      "CHART_TITLE": "Distribució per grup",
      "BACK_TO_ALL": "Mostra-ho tot",
      "TABLE": {
        "INBOX": "Safata d'entrada",
        "LABEL": "Etiqueta",
        "CONVERSATIONS": "Converses",
        "MESSAGES": "Missatges",
        "MESSAGES_TOOLTIP": "Nombre total de missatges sortints",
        "AI_MESSAGES": "Respostes d'IA",
        "AI_MESSAGES_TOOLTIP": "Nombre total de respostes d'IA, seguit del recompte de valoracions positives i negatives dels usuaris finals",
        "THUMBS_UP_TOOLTIP": "Nombre de respostes d'IA valorades positivament (polze amunt) pels usuaris finals",
        "THUMBS_DOWN_TOOLTIP": "Nombre de respostes d'IA valorades negativament (polze avall) pels usuaris finals",
        "PREPARED": "Respostes preparades",
        "PERCENTAGE": "%",
        "PERCENTAGE_TOOLTIP": "Percentatge de missatges d'aquest grup respecte al total de missatges",
        "BOT_RESPONSES": "% de respostes d'IA",
        "SUGGESTION_USED": "Respostes utilitzades",
        "SUGGESTION_USED_TOOLTIP": "Percentatge de respostes preparades d'aquest grup que han utilitzat els agents",
        "SUGGESTION_NOT_USED": "Respostes no utilitzades",
        "SUGGESTION_NOT_USED_TOOLTIP": "Percentatge de missatges d'aquest grup que tenien una resposta preparada però no es va utilitzar"
      },
      "NOTES": {
        "TITLE": "Com es calculen les mètriques",
        "CONVERSATIONS": "Nombre de converses amb almenys un missatge sortint en el període seleccionat.",
        "MESSAGES": "Nombre total de missatges sortints (no privats) enviats en el període seleccionat. Inclou tant els missatges generats per IA com els escrits per persones.",
        "PERCENTAGE": "Proporció dels missatges d'aquest grup respecte al total de missatges sortints de tots els grups.",
        "AI_MESSAGES": "Nombre de missatges sortints enviats automàticament pel bot d'IA (sense incloure les respostes preparades per als agents). Els números entre parèntesis indiquen quantes d'aquestes respostes s'han valorat positivament (polze amunt) i negativament (polze avall) els usuaris finals.",
        "PREPARED": "Nombre de suggeriments de copilot (respostes preparades) generats pel bot d'IA per als agents en el període seleccionat. Són missatges privats visibles només pels agents i no es compten com a missatges sortints, per la qual cosa aquest número pot no coincidir amb la columna Missatges.",
        "SUGGESTION_USED": "Percentatge de respostes preparades d'aquest grup que han utilitzat els agents. Pot no coincidir amb el recompte de Respostes preparades perquè també pot incloure suggeriments generats en períodes anteriors.",
        "SUGGESTION_NOT_USED": "Percentatge de missatges sortints d'aquest grup en què hi havia un suggeriment de copilot disponible, però l'agent va respondre sense utilitzar-lo. Només es compta quan l'agent ha enviat realment una resposta. Pot no coincidir amb el recompte de Respostes preparades perquè també pot incloure suggeriments generats en períodes anteriors."
      }
    }
  },
  "OVERVIEW_REPORTS": {
    "HEADER": "Resum",
    "LIVE": "En directe",
    "ACCOUNT_CONVERSATIONS": {
      "HEADER": "Obrir converses",
      "LOADING_MESSAGE": "S'estan carregant les mètriques de les converses...",
      "OPEN": "Obrir",
      "UNATTENDED": "Sense assistència",
      "UNASSIGNED": "Sense assignar",
      "PENDING": "Pendent"
    },
    "CONVERSATION_HEATMAP": {
      "HEADER": "Trànsit de conversa",
      "NO_CONVERSATIONS": "Sense converses",
      "CONVERSATION": "{count} conversa",
      "CONVERSATIONS": "{count} converses",
      "DOWNLOAD_REPORT": "Download report"
    },
    "AGENT_CONVERSATIONS": {
      "HEADER": "Converses per agents",
      "LOADING_MESSAGE": "S'estan carregant les mètriques dels agents...",
      "NO_AGENTS": "No hi ha converses per part dels agents",
      "TABLE_HEADER": {
        "AGENT": "Agent",
        "OPEN": "Obrir",
        "UNATTENDED": "Sense assistència",
        "STATUS": "Estat"
      }
    },
    "TEAM_CONVERSATIONS": {
      "ALL_TEAMS": "All Teams",
      "HEADER": "Conversations by teams",
      "LOADING_MESSAGE": "Loading team metrics...",
      "NO_TEAMS": "There is no data available",
      "TABLE_HEADER": {
        "TEAM": "Equip",
        "OPEN": "Obrir",
        "UNATTENDED": "Sense assistència",
        "STATUS": "Estat"
      }
    },
    "AGENT_STATUS": {
      "HEADER": "Estat de l'agent",
      "ONLINE": "En línia",
      "BUSY": "Ocupat",
      "OFFLINE": "Fora de línia"
    }
  },
  "DAYS_OF_WEEK": {
    "SUNDAY": "Diumenge",
    "MONDAY": "Dilluns",
    "TUESDAY": "Dimarts",
    "WEDNESDAY": "Dimecres",
    "THURSDAY": "Dijous",
    "FRIDAY": "Divendres",
    "SATURDAY": "Dissabte"
  },
  "SLA_REPORTS": {
    "HEADER": "Informes SLA",
    "NO_RECORDS": "Les converses aplicades per l'SLA no estan disponibles.",
    "LOADING": "S'estan carregant dades del SLA...",
    "DOWNLOAD_SLA_REPORTS": "Descarregar informes SLA",
    "DOWNLOAD_FAILED": "No s'han pogut baixar els informes SLA",
    "DROPDOWN": {
      "ADD_FIlTER": "Afegeix un filtre",
      "CLEAR_ALL": "Esborrar tot",
      "CLEAR_FILTER": "Esborra els filtres",
      "EMPTY_LIST": "No s'ha trobat agents",
      "NO_FILTER": "No hi ha filtres disponibles",
      "SEARCH": "Cerca filtre",
      "INPUT_PLACEHOLDER": {
        "SLA": "Nom del SLA",
        "AGENTS": "Nom de l'Agent",
        "INBOXES": "Nom de la safata d'entrada",
        "LABELS": "Nom de l'etiqueta",
        "TEAMS": "Nom de l'equip"
      },
      "SLA": "Política SLA",
      "INBOXES": "Safata d'entrada",
      "AGENTS": "Agent",
      "LABELS": "Etiqueta",
      "TEAMS": "Equip"
    },
    "WITH": "with",
    "METRICS": {
      "HIT_RATE": {
        "LABEL": "Proporció d'encerts",
        "TOOLTIP": "El percentatge de SLA creats s'ha completat correctament"
      },
      "NO_OF_MISSES": {
        "LABEL": "Nombre de faltes",
        "TOOLTIP": "SLA total faltes en un període determinat"
      },
      "NO_OF_CONVERSATIONS": {
        "LABEL": "Número de Converses",
        "TOOLTIP": "Nombre total de converses amb SLA"
      }
    },
    "TABLE": {
      "HEADER": {
        "POLICY": "Política",
        "CONVERSATION": "Converses",
        "AGENT": "Agent"
      },
      "VIEW_DETAILS": "Veure Detalls"
    }
  },
  "SUMMARY_REPORTS": {
    "SUBTOTAL": "Subtotal",
    "NO_TEAM": "Sense equip",
    "GROUP_BY_TEAMS": "Agrupa per equips",
    "INBOX": "Safata d'entrada",
    "AGENT": "Agent",
    "TEAM": "Equip",
    "LABEL": "Etiqueta",
    "TOTAL": "Total",
    "AVG_RESOLUTION_TIME": "Avg. Resolution Time",
    "AVG_FIRST_RESPONSE_TIME": "Avg. First Response Time",
    "AVG_REPLY_TIME": "Avg. Customer Waiting Time",
    "RESOLUTION_COUNT": "Total de resolucions",
    "CONVERSATIONS": "Nre. de converses",
    "OUTGOING_CHATS": "Xats sortints",
    "OUTGOING_EMAILS": "Correus sortints",
    "PHONE_CALLS": "Trucades telefòniques",
    "INBOUND_CALLS": "Trucades entrants",
    "OUTBOUND_CALLS": "Trucades sortints",
    "TOTAL_ACTIVITIES": "Total d'activitats",
    "ONLINE_TIME": "Temps en línia",
    "QUEUE_AVAILABLE_TIME": "Temps disponible a la cua",
    "TOOLTIPS": {
      "OUTGOING_CHATS": "Nombre de missatges sortints enviats per aquest agent",
      "OUTGOING_EMAILS": "Nombre de correus sortints enviats per aquest agent",
      "PHONE_CALLS": "Nombre total de trucades telefòniques assignades a aquest agent (suma de trucades entrants i sortints)",
      "TOTAL_ACTIVITIES": "Nombre total d'activitats: trucades entrants + trucades sortints + xats sortints + correus sortints",
      "INBOUND_CALLS": "Nombre de trucades entrants assignades a aquest agent",
      "OUTBOUND_CALLS": "Nombre de trucades sortints assignades a aquest agent",
      "AVG_FIRST_RESPONSE_TIME": "Temps mitjà des de la creació de la conversa fins a la primera resposta de l'agent en les converses assignades a aquest agent",
      "AVG_RESOLUTION_TIME": "Temps mitjà des de la creació de la conversa fins a la resolució en les converses assignades a aquest agent",
      "AVG_REPLY_TIME": "Temps mitjà que esperen els clients entre el seu missatge i la resposta de l'agent en les converses assignades a aquest agent",
      "ONLINE_TIME": "Temps total en què l'agent ha estat en línia o ocupat durant el període seleccionat",
      "QUEUE_AVAILABLE_TIME": "Temps total en què l'agent ha estat disponible a les cues de telèfon durant el període seleccionat"
    }
  },
  "PHONE_REPORTS": {
    "HEADER": "Informes de telèfon",
    "DESCRIPTION": "Fes seguiment de les mètriques de trucades telefòniques amb dades detallades de trucades entrants i sortints, agrupades per agent o safata d'entrada per a una anàlisi completa.",
    "DOWNLOAD_PHONE_REPORTS": "Descarregar informes de telèfon",
    "GROUP_BY": {
      "LABEL": "Agrupa per",
      "AGENT": "Agent",
      "INBOX": "Safata d'entrada"
    },
    "TABLE": {
      "TOTAL_CALLS": "Total",
      "INBOUND_CALLS": "Entrants",
      "OUTBOUND_CALLS": "Sortints",
      "FAILED_OUTBOUND_CALLS": "Sortints fallides",
      "AVG_AGENT_HANDLED_DURATION": "Durada mitjana",
      "TOTAL_AGENT_HANDLED_DURATION": "Durada total",
      "AVG_RINGING_TIME": "Temps mitjà de timbre",
      "CONNECTED_OUTBOUND_PERCENTAGE": "% d'èxit",
      "UNIQUE_CALLERS": "Trucants únics",
      "UNIQUE_CALLED_CONTACTS": "Trucats únics",
      "UNANSWERED_MISSED_CALLS": "Perdudes sense seguiment",
      "UNANSWERED_MISSED_PERCENTAGE": "% de perdudes sense resposta",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_CALLS": "Perdudes sense seguiment, retrucades insuficients",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_PERCENTAGE": "% de perdudes sense seguiment, retrucades insuficients"
    },
    "TOOLTIPS": {
      "TOTAL_CALLS": "Nombre total de totes les trucades (incloses les no connectades)",
      "INBOUND_CALLS": "Nombre de trucades connectades",
      "OUTBOUND_CALLS": "Nombre de totes les trucades sortints (incloses les no connectades)",
      "FAILED_OUTBOUND_CALLS": "Nombre de trucades sortints que no s'han pogut connectar",
      "AVG_AGENT_HANDLED_DURATION": "Durada mitjana de les trucades gestionades pels agents",
      "TOTAL_AGENT_HANDLED_DURATION": "Durada total de totes les trucades gestionades pels agents",
      "AVG_RINGING_TIME": "Temps mitjà que les trucades passen sonant abans de ser ateses",
      "CONNECTED_OUTBOUND_PERCENTAGE": "Percentatge de trucades sortints que s'han connectat correctament",
      "UNIQUE_CALLERS": "Nombre de contactes únics que han fet trucades entrants",
      "UNIQUE_CALLED_CONTACTS": "Nombre de contactes únics als quals s'ha trucat mitjançant trucades sortints",
      "UNANSWERED_MISSED_CALLS": "Nombre de trucades perdudes en què no s'ha fet cap trucada de retorn amb èxit (trucada connectada). Pot incloure trucades que encara es puguin gestionar dins de la jornada laboral",
      "UNANSWERED_MISSED_PERCENTAGE": "Percentatge de trucants únics les trucades dels quals s'han perdut sense seguiment (trucades perdudes sense resposta / trucants únics)",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_CALLS": "Nombre de trucades perdudes amb menys de 2 intents de trucada de retorn. Pot incloure trucades que encara es puguin gestionar dins de la jornada laboral",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_PERCENTAGE": "Percentatge de trucants únics amb menys de 2 intents de trucada de retorn ((perdudes sense seguiment - gestionades suficientment) / trucants únics)"
    }
  }
}
